import { InputHelperText, useInput, useTranslate } from "react-admin";
import React, { useMemo } from "react";
import { TextField, makeStyles } from "@material-ui/core";

import { Autocomplete } from "@material-ui/lab";
import classnames from "classnames";
import { get } from "lodash";
import { useFormState } from "react-final-form";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(2),

    "& label": {
      marginTop: theme.spacing(0.5),
    },
    minWidth: 250,
    "& > div:first-child > div": {
      paddingTop: theme.spacing(2),
    },
    "& > div:first-child": {
      marginBottom: -theme.spacing(4),
    },
    "& > .MuiFormControl-root > .MuiInputBase-root": {
      marginTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  tag: {
    height: "auto",
    marginTop: theme.spacing(1),
    marginBottom: -theme.spacing(0.5),
    padding: theme.spacing(0.5),
    backgroundColor: "rgba(0, 0, 0, 0.09)",
    "& > span": {
      whiteSpace: "break-spaces",
    },
  },
}));
const useGlobalStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(5),
  },
}));
const AutocompleteInput = ({
  choices,
  multiple,
  optionText = "name",
  helperText = null,
  resource,
  className,
  defaultValue = null,
  ...props
}) => {
  const formState = useFormState();
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const {
    input: { name, onChange, ...rest },
    meta: { touched, error },
    isRequired,
  } = useInput(props);
  const translate = useTranslate();
  const label = useMemo(
    () =>
      translate(
        get(
          props,
          "label",
          `resources.${resource}.fields.${get(props, "source")}`
        )
      ),
    [props, translate, resource]
  );
  const helperTextContent = useMemo(() => {
    return translate(helperText);
  }, [helperText, translate]);
  const selectedValues = useMemo(() => {
    const currentSelectedValues = multiple
      ? get(formState, `values.${get(props, "source")}`, []).map(({ id }) => id)
      : get(formState, `values.${get(props, "source")}`);

    let selection = choices.filter((c) =>
      multiple
        ? currentSelectedValues.indexOf(c.id) !== -1
        : currentSelectedValues === c.id
    );
    return multiple ? selection : get(selection, "[0]", null);
  }, [formState, props, choices, multiple]);
  const handleChange = (_, values) => {
    onChange(multiple ? values.map(({ id }) => id) : get(values, "id"));
  };
  const getOptionLabel = (option) => {
    return typeof optionText === "function"
      ? optionText(option)
      : get(option, optionText);
  };
  return (
    <div
      className={classnames(
        className,
        globalClasses.root,
        // basePath è valorizzato solo quando sei all'interno di un form di creazione/modifica.
        props.basePath && globalClasses.formField
      )}
    >
      <Autocomplete
        {...rest}
        multiple={multiple}
        classes={classes}
        options={choices}
        onChange={handleChange}
        value={selectedValues}
        getOptionLabel={getOptionLabel}
        renderInput={(params) => (
          <TextField
            error={touched && error ? true : false}
            helperText={
              (helperText !== false && helperText !== null) ||
              (touched && error) ? (
                <InputHelperText
                  style={{ marginBottom: 32 }}
                  helperText={helperTextContent}
                  touched={touched}
                  error={error}
                />
              ) : null
            }
            required={isRequired}
            label={label}
            variant={"filled"}
            {...params}
          />
        )}
      />
    </div>
  );
};

export default AutocompleteInput;
